import { defineStore } from 'pinia';
import { WebsiteApiHelper } from '@/helpers/global/baseAPI.helper';

const useUserInfoStore = defineStore('user-info', {
  state: () => ({
    userInfo: undefined,
    companyInfo: undefined,
    companyAddresses: [],
    companyAddressesTotalPages: 0,
    companyAddressesCurrentPage: 1,
    companyAddressesIsEmpty: false,
  }),
  actions: {
    fetchUserInfo() {
      if (this.userInfo === undefined) {
        WebsiteApiHelper.get('/user-profile/me/').then((userInfoRes) => {
          if (userInfoRes && userInfoRes.email) {
            this.userInfo = userInfoRes;
          }
        });
      }
    },
    fetchCompanyInfo() {
      if (this.companyInfo === undefined) {
        WebsiteApiHelper.get('/customer-company/me/').then((companyInfoRes) => {
          if (companyInfoRes && companyInfoRes.name) {
            this.companyInfo = companyInfoRes;
          }
        });
      }
    },
    fetchCompanyAddresses(currentPage: number = 1) {
      if (this.companyAddressesCurrentPage !== currentPage || currentPage === 1) {
        WebsiteApiHelper.get('/customer-company-address/').then((companyAddressesRes) => {
          if (companyAddressesRes !== undefined && companyAddressesRes.results.length > 0) {
            this.companyAddresses = [];
            companyAddressesRes.results.forEach((address) => {
              this.companyAddresses.push(address);
            });
            this.companyAddressesTotalPages = companyAddressesRes.num_page;
            this.companyAddressesCurrentPage = companyAddressesRes.page;
          } else {
            this.companyAddressesIsEmpty = true;
            this.companyAddresses = [];
          }
        });
      }
    },
  },
});

export default useUserInfoStore;
